import React from 'react'
import { Select, Typography } from 'antd'
import { MetricKey, METRICS } from '../campaigns/PerformanceChart/types'

const { Text } = Typography

interface BarMetricSelectorProps {
  value: MetricKey
  onChange: (value: MetricKey) => void
  selectedMetrics: MetricKey[]
  className?: string
  title?: string
}

export const BarMetricSelector: React.FC<BarMetricSelectorProps> = ({
  value,
  onChange,
  selectedMetrics,
  className = '',
  title = 'Display as Bar:'
}) => {
  if (selectedMetrics.length <= 1) return null

  return (
    <div className={`flex-1 min-w-[200px] ${className}`}>
      <Text strong className="mb-2 block">{title}</Text>
      <Select
        value={value}
        onChange={onChange}
        className="w-full"
        options={selectedMetrics.map(key => ({
          label: METRICS.find(m => m.key === key)?.label,
          value: key
        }))}
      />
    </div>
  )
}
